import BackendService from './BackendService';

async function getSale(id) {
  return BackendService.getData(`/sales/${id}/`);
}
async function getSales(params) {
  return BackendService.getData('/v2/sales/', {}, params);
}
async function createSale(data = {}) {
  return BackendService.postData('/v2/sales/', data, { 'App-Version': '2.7.0' });
}
async function updateSale(id, data = {}) {
  return BackendService.patch(`/sales/${id}/`, data);
}
async function getHighestInvoiceNumber(prefix = '') {
  return BackendService.getData(`/sales/highest-bill-no/?prefix=${prefix}`);
}


const SaleService = {
  getSale,
  getSales,
  createSale,
  updateSale,
  getHighestInvoiceNumber,
};

export default SaleService;
